import { EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES } from 'components/BusinessToolForm/Sections/ExecutiveSummary/FinancialNeedsExecSummary/utils/form';

import colors from 'styles/sass-variables.module.scss';

export const getChartBgColor = (key: string, isOutlined?: boolean) => {
  const chartColorsMap = new Map<string, string>([
    [
      EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.RESEARCH_COST,
      isOutlined ? colors.gantt_blue_border : colors.gantt_in_progress,
    ],
    [EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.MARKETING_COST, colors.gantt_todo],
    [EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.WORKING_CAPITAL_COST, colors.gantt_done],
    [EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.EQUIPMENT_COST, colors.chart_lightblue],
    [EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.CONSTRUCTION_COST, colors.chart_pink],
    [EXECUTIVE_SUMMARY_FINANCING_NEEDS_NAMES.OTHER_COST, colors.chart_grey],
  ]);

  return chartColorsMap.get(key) ?? '';
};
